/* ML infinite scroll - 31 Aug 2026 -------------------------------------------
   Eli: "i dont like clicking page 2 - just make it open more items on scroll down."

   Appends the next page's cards into the existing grid and swaps the pagination block
   for the new one, so .next always points one page further on. The pagination stays in
   the DOM (it is where the next URL comes from, and it is the no-JS fallback); CSS hides
   it once this script has run.

   TRAPS honoured here:
   - credentials:'same-origin'. A fetch with credentials:'omit' gets a CACHED, UNFILTERED
     page back from Shopify, which would append the wrong products on a filtered page.
   - No MutationObserver. The one on the filter bar's price painter hung the renderer once.
     A scroll listener plus a sentinel is enough.
   - The grid lives inside #CollectionAjaxContent and is replaced wholesale when a filter
     is applied, so everything is looked up fresh on every call - nothing is cached in a
     variable across a swap.
   - Impulse fades cards in with AOS, which only scans at page load. custom.css already
     forces opacity:1 on images inside #CollectionAjaxContent, which covers these too.
--------------------------------------------------------------------------- */
(function(){
  var GRID = '#CollectionAjaxContent .collection-grid__wrapper .grid--uniform';
  var PAG  = '#CollectionAjaxContent .pagination';
  var loading = false;
  var lastHref = null;
  var failures = 0;
  /* Wholesale Gorilla removes roughly two cards in three for a logged-out visitor, so an
     appended page often barely lengthens the document and the sentinel stays in range.
     Without a cap one trip to the bottom would pull the whole collection - 29 pages on
     /collections/all. Chain at most twice, then wait for the visitor to scroll again. */
  var chain = 0;
  var CHAIN_MAX = 2;

  function grid(){ return document.querySelector(GRID); }
  function pag(){ return document.querySelector(PAG); }
  function nextHref(){
    var a = document.querySelector(PAG + ' .next a[href]');
    return a ? a.getAttribute('href') : null;
  }

  function sentinel(){
    var s = document.getElementById('MLScrollSentinel');
    var g = grid();
    if(!g) return null;
    if(!s || !g.parentNode.contains(s)){
      s = document.createElement('div');
      s.id = 'MLScrollSentinel';
      s.className = 'ml-scroll-sentinel';
      g.parentNode.insertBefore(s, g.nextSibling);
    }
    return s;
  }

  function say(text){
    var s = sentinel();
    if(s) s.textContent = text || '';
  }

  function load(){
    if(loading || failures >= 3) return;
    var href = nextHref();
    if(!href || href === lastHref) return;
    loading = true;
    lastHref = href;
    say('Loading more\u2026');
    fetch(href, { credentials: 'same-origin' })
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.collection-grid__wrapper .grid--uniform');
        var here  = grid();
        if(!here || !fresh){ loading = false; failures++; say(''); return; }
        var frag = document.createDocumentFragment();
        Array.prototype.slice.call(fresh.children).forEach(function(c){
          frag.appendChild(document.importNode(c, true));
        });
        here.appendChild(frag);

        var oldP = pag();
        var newP = doc.querySelector('.pagination');
        if(oldP){
          if(newP){ oldP.parentNode.replaceChild(document.importNode(newP, true), oldP); }
          else { oldP.parentNode.removeChild(oldP); }
        }
        say('');
        loading = false;
        failures = 0;
        /* Wholesale Gorilla watches the grid and pulls trade-only cards back out; give it
           and anything else that cares a hook, then see whether more is still needed. */
        document.dispatchEvent(new CustomEvent('ml:grid-appended'));
        if(chain < CHAIN_MAX){ chain++; window.setTimeout(check, 300); }
        else { say(''); }
      })
      .catch(function(){ loading = false; failures++; lastHref = null; say(''); });
  }

  function check(){
    var s = sentinel();
    if(!s) return;
    if(!nextHref()) { s.textContent = ''; return; }
    var r = s.getBoundingClientRect();
    if(r.top < window.innerHeight + 700) load();
  }

  document.documentElement.classList.add('ml-infinite');
  window.addEventListener('scroll', function(){ chain = 0; check(); }, { passive: true });
  window.addEventListener('resize', check, { passive: true });
  window.addEventListener('popstate', function(){ lastHref = null; failures = 0; chain = 0; });
  document.addEventListener('click', function(e){
    /* a filter was applied - the grid is about to be replaced */
    if(e.target && e.target.closest && e.target.closest('[data-ml-fbar], .ml-fchip, .ml-fclear')){
      lastHref = null; failures = 0;
    }
  }, true);
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', check); }
  window.setTimeout(check, 900);
})();
